import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { format } from 'date-fns';
import { FunctionComponent } from 'react';
import { useQuery } from 'react-query';
import { Loading } from 'src/components/elements/Loading';
import { getWeights } from '../api/getWeights';
import { weightsToAverageWeightPerWeek } from '../utils/weightUtils';

export const WeeklyWeights: FunctionComponent<{}> = () => {
  const { isLoading, data: avgWeightPerWeek } = useQuery(
    'weights',
    getWeights,
    {
      select: (data) => weightsToAverageWeightPerWeek(data.weights),
    }
  );

  if (isLoading) return <Loading />;

  return (
    <TableContainer component={Paper} sx={{ maxWidth: 330 }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell colSpan={4} sx={{ textAlign: 'center' }}>
              <Typography>Weekly Weights</Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {avgWeightPerWeek?.map((w) => (
            <TableRow key={w.key}>
              <TableCell>{w.year}</TableCell>
              <TableCell>{format(w.start, 'dd-MMM')}</TableCell>
              <TableCell>{format(w.end, 'dd-MMM')}</TableCell>
              <TableCell style={{ textAlign: 'right', paddingRight: 20 }}>
                {w.weight.toFixed(2)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
